import { render } from "./OffsiteModal.vue?vue&type=template&id=87c79b44&scoped=true"
import script from "./OffsiteModal.vue?vue&type=script&lang=js"
export * from "./OffsiteModal.vue?vue&type=script&lang=js"

import "./OffsiteModal.vue?vue&type=style&index=0&id=87c79b44&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jamesc\\source\\repos\\ul-web-plugins\\src\\UL.VueCadPlugin.Client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87c79b44"]])

export default __exports__